import { render, staticRenderFns } from "./TourEmpty.vue?vue&type=template&id=656dbfd5&scoped=true&"
var script = {}
import style0 from "./TourEmpty.vue?vue&type=style&index=0&id=656dbfd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656dbfd5",
  null
  
)

export default component.exports